const showCampaignDropdown = (element, dropdownRef, setShadowActive) => {
  element.parentNode.classList.add('visible');
  dropdownRef.current.classList.add('visible');
  setShadowActive(true);
};

export default showCampaignDropdown;
